import {Component, Inject, Input} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

import {DialogButtonTypesEnum, DialogConfigInterface} from 'appShared/components';
import {ApiError, SesService} from '@spa/api';
import {PermissionRuleInterface} from 'appShared/interfaces';
import {RemoveFeedForm} from 'appEntries/panel/forms';
import {MarketDataFeedsAddMessages} from 'appAssets/messages';
import {AlertsService} from 'appShared/services';
import {MarketDataFeedsFormErrorStatesEnum} from 'appEntries/panel/enums';
import {MarketDataFeedAndBundleDeleteInterface} from 'appEntries/panel/interfaces';
import {PermissionRulesTrait} from 'appEntries/panel/traits';
import {PanelBaseMarketDataFormDialogComponent} from 'appEntries/panel/dialogs/ses/panel-base-market-data-form-dialog.component';

@Component({
    selector: 'app-market-data-remove-feeds-bundle',
    templateUrl: './market-data-remove-feeds-bundle.component.html'
})
export class MarketDataRemoveFeedsBundleComponent extends PanelBaseMarketDataFormDialogComponent<MarketDataRemoveFeedsBundleComponent> {

    @Input() public feeds: MarketDataFeedAndBundleDeleteInterface[];
    public form: RemoveFeedForm;
    public manageFeedPermissionRule: PermissionRuleInterface;
    public manageBundlePermissionRule: PermissionRuleInterface;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: {
            config: DialogConfigInterface,
            feeds: MarketDataFeedAndBundleDeleteInterface[]
        },
        private readonly sesService: SesService,
        protected alertsService: AlertsService,
        public dialogRef: MatDialogRef<MarketDataRemoveFeedsBundleComponent>,
    ) {
        super(dialogRef, alertsService);
        this.manageBundlePermissionRule = PermissionRulesTrait.getMarketDataFeedBundleManagementPermissionRule();
        this.manageFeedPermissionRule = PermissionRulesTrait.getMarketDataFeedManagementPermissionRule();
        this.config = data.config;
        this.feeds = data.feeds;
    }

    initForm(): void {
        this.form = new RemoveFeedForm(this.sesService, this.feeds);
        this.form.initForm();

        const formFeedChangeSubscription = this.form.formGroup.valueChanges.subscribe((data: object) => {
            const selectedBundleFirstIndex = Object.keys(data).findIndex((key: string) => data[key] > 0);
            this.config.buttons.find(button => button.type === DialogButtonTypesEnum.Confirm).hidden = selectedBundleFirstIndex < 0;
        });

        this.subscriptions.push(formFeedChangeSubscription);

        const formBundleChangeSubscription = this.form.feedBundleFromGroup.valueChanges.subscribe((data: object) => {
            const selectedBundleFirstIndex = Object.keys(data).findIndex((key: string) => data[key] > 0);
            this.config.buttons.find(button => button.type === DialogButtonTypesEnum.Confirm).hidden = selectedBundleFirstIndex < 0;
        });

        this.subscriptions.push(formBundleChangeSubscription);
    }

    getErrorMessageByApiError(error: ApiError): string {
        if (error.status === MarketDataFeedsFormErrorStatesEnum.CreateMarketDataFeedFailed) {
            return MarketDataFeedsAddMessages.MarketDataFeedDeletionFailed.message;
        }

        return MarketDataFeedsAddMessages.UnknownError.message;
    }

    getSuccessFormMessage(): string {
        return MarketDataFeedsAddMessages.MarketDataFeedDeletionSucceed.message;
    }
}
